import { EditorView, basicSetup, EditorState, json, oneDark } from "./vendor/codemirror.bundle.js";

const style = document.createElement('style');
style.textContent = `
    :host { display: block; }
    .editor-container { height: 100%; }
    .cm-editor { height: 100%; border-radius: 6px; font-size: 13px; }
    .cm-scroller { overflow: auto; }
`;

export class AppJsonEditor extends HTMLElement {
    view = null;
    pendingValue = '';

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        const container = document.createElement('div');
        container.className = 'editor-container';
        this.shadowRoot.replaceChildren(style.cloneNode(true), container);

        this.view = new EditorView({
            state: EditorState.create({
                doc: this.pendingValue,
                extensions: [basicSetup, json(), oneDark, EditorView.lineWrapping],
            }),
            parent: container,
            root: this.shadowRoot,
        });
    }

    disconnectedCallback() {
        this.view?.destroy();
        this.view = null;
    }

    getValue() {
        return this.view ? this.view.state.doc.toString() : this.pendingValue;
    }

    setValue(value) {
        this.pendingValue = value ?? '';
        if (!this.view) return;
        this.view.dispatch({
            changes: { from: 0, to: this.view.state.doc.length, insert: this.pendingValue },
        });
    }
}

customElements.define('app-json-editor', AppJsonEditor);